<template>
  <div class="settings">
    <div class="toggle">
      <button class="btn" title="Toggle menu" @click="isActive = !isActive">
        <fa :icon="['fas', 'cog']" />
      </button>
    </div>
    <div class="settings__items" :class="{ active: isActive }">
      <div class="item">
        <button class="btn" title="Zoom in (shift +)" @click="$emit('zoom-in')">
          <fa :icon="['fas', 'search-plus']" />
        </button>
      </div>
      <div class="item">
        <button
          class="btn"
          title="Zoom out (shift -)"
          @click="$emit('zoom-out')"
        >
          <fa :icon="['fas', 'search-minus']" />
        </button>
      </div>
      <div class="item-divider"></div>
      <div class="item">
        <button
          class="btn"
          :class="{ disabled: disableActionUndo }"
          title="Undo"
          @click="$emit('action-undo')"
        >
          <fa :icon="['fas', 'undo']" />
        </button>
      </div>
      <div class="item">
        <button
          class="btn"
          :class="{ disabled: disableActionRedo }"
          title="Redo"
          @click="$emit('action-redo')"
        >
          <fa :icon="['fas', 'redo']" />
        </button>
      </div>
      <div class="item-divider"></div>
      <div class="item">
        <button
          class="btn"
          :class="{ disabled: disableAlign }"
          title="Align horizontal centres"
          @click="$emit('align-horizontal')"
        >
          <AlignHorizontal class="custom-icon" />
        </button>
      </div>
      <div class="item">
        <button
          class="btn"
          :class="{ disabled: disableAlign }"
          title="Align vertical centres"
          @click="$emit('align-vertical')"
        >
          <AlignVertical class="custom-icon" />
        </button>
      </div>
      <div class="item">
        <button
          class="btn"
          :class="{ disabled: disableDistribute }"
          title="Distribute horizontally"
          @click="$emit('distribute-horizontal')"
        >
          <SpacingHorizontal class="custom-icon" />
        </button>
      </div>
      <div class="item">
        <button
          class="btn"
          :class="{ disabled: disableDistribute }"
          title="Distribute vertically"
          @click="$emit('distribute-vertical')"
        >
          <SpacingVertical class="custom-icon" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import AlignHorizontal from "@/components/Icons/AlignHorizontal";
import AlignVertical from "@/components/Icons/AlignVertical";
import SpacingHorizontal from "@/components/Icons/SpacingHorizontal";
import SpacingVertical from "@/components/Icons/SpacingVertical";

export default {
  components: {
    AlignHorizontal,
    AlignVertical,
    SpacingHorizontal,
    SpacingVertical
  },

  props: {
    actionIndex: {
      type: Number,
      default: -1
    },
    actionCount: {
      type: Number,
      default: 0
    },
    activeElementType: {
      type: String,
      default: ""
    },
    activeElement: {
      type: Object,
      default: () => {}
    },
    selectedElementsCount: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      isActive: true
    };
  },

  computed: {
    disableActionUndo() {
      return this.actionIndex === -1;
    },

    disableActionRedo() {
      return (
        this.actionCount - 1 === this.actionIndex || this.actionCount === 0
      );
    },

    disableAlign() {
      return this.selectedElementsCount < 2;
    },

    disableAlign() {
      return this.selectedElementsCount < 2;
    },

    disableDistribute() {
      return this.selectedElementsCount < 3;
    }
  }
};
</script>
<style lang="scss" scoped>
.settings {
  left: 0;
  position: absolute;
  top: 0;
  z-index: 9998;

  &__items {
    background: #fff;
    border-radius: 0 3px 3px 0;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 200ms ease-in-out;

    &.active {
      transform: translateX(0);
    }

    .item {
      align-items: center;
      display: flex;
      justify-content: center;
      height: 30px;
      width: 30px;
    }

    .item-divider {
      height: 5px;
      position: relative;
      width: 30px;

      &::before {
        background-color: #b9b9b9;
        content: "";
        height: 1px;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 70%;
      }
    }
  }

  .btn {
    color: #393942;
    height: 24px;
    padding: 0;
    width: 24px;

    &.disabled {
      opacity: 0.5;
    }

    .custom-icon {
      display: flex;
    }
  }

  .toggle {
    background: #fff;
    border-radius: 0 3px 3px 0;
    align-items: center;
    display: flex;
    justify-content: center;
    height: 30px;
    margin: 4px 0;
    width: 30px;
  }
}
</style>
